export default __webpack_public_path__ + "staticlp1/media/assinaturas-1.2d929730.png";